import { render } from "./AuthNavbar.vue?vue&type=template&id=70086b89&scoped=true"
import script from "./AuthNavbar.vue?vue&type=script&lang=js"
export * from "./AuthNavbar.vue?vue&type=script&lang=js"

import "./AuthNavbar.vue?vue&type=style&index=0&id=70086b89&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70086b89"]])

export default __exports__